import { render, staticRenderFns } from "./TeamInviteRoleSelection.vue?vue&type=template&id=5bf5318a&scoped=true"
import script from "./TeamInviteRoleSelection.vue?vue&type=script&lang=js"
export * from "./TeamInviteRoleSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5318a",
  null
  
)

export default component.exports